const initialState = {
  params: {},
  updated: false,
  propertyGroups: {},
  groupCounts: {},
  properties: {},
  services: {buy:[], sell: []},
  parentServices: [],
  allservices: [],
  roles: [],
  questions: [],
  searchQuery: {},
  customFields: [],
  responses: [],
  responseMessages: [],
  requestResponsesCount: {},
  uniqueServices: [],
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_PARAMS":
      return { ...state, params: action.payload, updated: true };
    case "PROPERTY_GROUPS":
      const propertyGroups = { ...state.propertyGroups };
      propertyGroups[action.payload.propertyId] =
        action.payload.groupsDataObject;
      return { ...state, propertyGroups: propertyGroups };
    case "GROUP_COUNTS":
      return { ...state, groupCounts: action.payload };
    case "PROPERTY_IMAGES":
      if (Object.keys(action.payload.images).length > 0) {
        return {
          ...state,
          properties: {
            ...state.properties,
            [action.payload.propertyId]: action.payload.images,
          },
        };
      } else {
        return {
          ...state,
          properties: { ...state.properties, [action.payload.propertyId]: {} },
        };
      }
    case "HOME_SERVICES":
      return { ...state, services:{...state.services, [ action.payload.side]: action.payload.services}};
    case "HOME_QUESTIONS":
      return { ...state, questions: action.payload };
    case "HOME_QUESTIONS_OPTIONS": {
      const question = state.questions.find(
        (q) => q.id === action.payload.questionsId
      );
      if (question) {
        question.options = action.payload.options;
      }
      return { ...state, questions: state.questions };
    }
    case "SAVE_SEARCH_QUERY": {
      return { ...state, searchQuery: { save: action.payload } };
    }
    case "GET_SEARCH_QUERY": {
      return { ...state, searchQuery: { list: action.payload } };
    }
    case "FETCH_CUSTOM_FIELDS": {
      return { ...state, customFields: action.payload };
    }
    case "GET_SEARCH_QUERY_RESPONSES": {
      return { ...state, responseMessages: action.payload.messages, responses: action.payload.responses };
    }
    case "GET_REQUEST_RESPONSES_COUNT": {
      const requestResponsesCount = { ...state.requestResponsesCount };
      requestResponsesCount[action.payload.publicId] = action.payload.count;
      return { ...state, requestResponsesCount };
    }
    case "HOME_ALL_SERVICES": {
      return { ...state, allservices: action.payload.services };
    }
    case "HOME_ALL_ROLES": {
      return { ...state, roles: action.payload.roles };
    }
    case "HOME_ALL_UNIQUE_SERVICES": {
      return { ...state, uniqueServices: action.payload.services };
    }
    case "FETCH_PARENT_SERVICES": {
      return { ...state, parentServices: action.payload.parentServices };
    }
    default:
      return state;
  }
};

export default searchReducer;
